import styled from "styled-components";

import SectionContainer from "../../../components/container/SectionContainer";
import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import SignatureImage from "../../../assets/images/vision/team_signature.svg";
import TitleImage from "../../../assets/images/vision/our_mission.svg";
import media from "styled-media-query";

const Title = styled.img`
	height: 38px;
	margin-bottom: 32px;
	width: fit-content;
`;
const Signature = styled.img`
	height: 28px;
	width: fit-content;
`;
const ImageView = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	position: relative;
`;
const Image = styled.img`
	width: 240px;
	height: 180px;
	border-radius: 16px;
	object-fit: cover;
	margin-bottom: 32px;
`;
const Lettering = styled.img`
	height: 80px;
	width: 139px;
	position: absolute;
	z-index: 1;
	left: 32px;
	${media.lessThan("medium")`
		left: 0px;
    `}
`;

const VisionRightStep = (props: VisionStepProps) => {
	const colors = {
		buttonBackground: ColorV2.surface.primary,
		buttonColor: "white",
		animation: ["#00315C", "#005AA8"],
	};

	return (
		<SectionContainer
			childrenProps={{ style: { marginTop: 0 } }}
			buttonProps={{
				style: {
					backgroundColor: colors.buttonBackground,
					color: colors.buttonColor,
				},
				children: "Estoy de acuerdo",
				onClick: () => props.onFinish({ data: true }),
			}}
		>
			<ImageView>
				<Lettering
					src={require("../../../assets/images/background/register/back_vision_letter.webp")}
				/>
				<Image
					src={require("../../../assets/images/background/register/back_vision.webp")}
				/>
			</ImageView>
			<Title src={TitleImage} />
			<Text type="p" style={{ marginBottom: 12 }}>
				Nos encantan las personas mayores y nos comprometemos a
				potenciar su papel protagonista en la sociedad del siglo XXI.
			</Text>
			<Text type="p" style={{ marginBottom: 12 }}>
				Pertenecer a nuestra comunidad significa comportarse con
				integridad, amabilidad y honestidad, respetando y apoyando la
				diversidad de raza, religión, género y orientación sexual.
			</Text>
			<Text type="p" style={{ marginBottom: 12 }}>
				Estamos creando una comunidad segura e inclusiva que sea un
				referente de apoyo a las personas mayores.
			</Text>
			<Text type="p" style={{ marginBottom: 24 }}>
				Con mucho cariño,
			</Text>
			<Signature src={SignatureImage} />
		</SectionContainer>
	);
};
export default VisionRightStep;
export interface VisionStepProps {
	onFinish: (result: { data?: boolean; error?: string }) => void;
}
